import { Config } from '../config';
import { userGroup } from '../enums';
import { User, Group } from '../interfaces';
import { HttpService } from './http.service';

const path = `${Config.API}/users`;

interface UpdateProfileInput extends Partial<User> {
  cognito_id: User['cognito_id'];
  password?: string;
}

export abstract class UserProfileService {
  public static getAll = (): Promise<User[]> => {
    return HttpService.fetchAuthorized(path).then((res) => {
      return res || [];
    });
  };

  public static getAllUserGroups = (): Promise<Group[]> => {
    return HttpService.fetchAuthorizedFleetless(`${path}/groups`).then((res) => {
      return res || [];
    });
  };

  public static getUsersFromGroup = (group_name: userGroup): Promise<User[]> => {
    return HttpService.fetchAuthorizedFleetless(`${path}/groups/${group_name}/members`).then((res) => {
      return res || [];
    });
  };

  public static searchUsers = (query?: string): Promise<[]> => {
    return HttpService.fetchAuthorized(`${path}/search${query ? `?q=${query}` : ''}`).then((res) => {
      return res || [];
    });
  };

  public static getMyProfile = (): Promise<User> => {
    return HttpService.fetchAuthorizedFleetless(`${path}/me`).then((responseFleetless) => responseFleetless);
  };

  public static updateProfile = (id: string, body: UpdateProfileInput): Promise<any> => {
    return HttpService.fetchAuthorized(`${path}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };

  public static deleteProfile = (id: string): Promise<any> => {
    return HttpService.fetchAuthorized(`${path}/${id}`, {
      method: 'DELETE',
    }).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };

  public static uploadAvatar = (userId: string, body: FormData): Promise<{ filepath: string; key: string }> => {
    return HttpService.fetchAuthorized(`${path}/${userId}/avatar`, {
      method: 'POST',
      body,
    }).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };

  public static uploadSignature = (userId: string, body: FormData): Promise<{ filepath: string; key: string }> => {
    return HttpService.fetchAuthorized(`${path}/${userId}/signature`, {
      method: 'POST',
      body,
    }).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };

  public static create = (body: UpdateProfileInput): Promise<any> => {
    return HttpService.fetchAuthorized(
      path,
      {
        method: 'POST',
        body: JSON.stringify(body),
      },
      undefined,
      true,
    ).then(
      (res) => Promise.resolve(res),
      (rej) => Promise.reject(rej),
    );
  };

  public static get = (id: string): Promise<User> => {
    return HttpService.fetchAuthorized(`${path}/${id}`).then((res) => res);
  };
}
